import { render, staticRenderFns } from "./CheckoutAnonimo.vue?vue&type=template&id=6d35d86c"
import script from "./CheckoutAnonimo.vue?vue&type=script&lang=js"
export * from "./CheckoutAnonimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports